(() => {
  'use strict';
  const root = document.querySelector('[data-ucw-pdp-product]');
  const store = window.UCWPrinters;
  if (!root || !store) return;
  const prompt = root.querySelector('[data-pdp-printer-prompt]');
  const save = root.querySelector('[data-pdp-printer-save]');
  if (!prompt || !save) return;
  save.parentElement.append(save);
  let revision = 0, selectedHandle = '';
  async function update() {
    const version = ++revision;
    const context = window.UCWPrinterContext;
    let printer = context?.active ? { handle: context.handle, name: context.printer } : null;
    if (!printer) {
      const result = await store.match(root.dataset.productHandle);
      if (version !== revision) return;
      if (result.status === 'match') printer = result.matches[0];
    }
    const choice = printer && [...document.querySelectorAll('[data-ucw-printer-choice]')].find(node => node.dataset.printerHandle === printer.handle || node.dataset.printerName.toLowerCase() === printer.name.toLowerCase());
    prompt.hidden = !!choice;
    const fit = await store.match(root.dataset.productHandle);
    if (version !== revision) return;
    const savedFit = fit.status === 'match';
    root.querySelectorAll('[data-pdp-all-printers]').forEach(link => { link.hidden = !!savedFit; });
    save.hidden = !choice;
    if (!choice) return;
    root.querySelectorAll('[data-pdp-source-printer-name]').forEach(link => {
      link.href = '/collections/' + encodeURIComponent(choice.dataset.printerHandle);
      link.textContent = choice.dataset.printerName;
    });
    if (selectedHandle !== choice.dataset.printerHandle) {
      selectedHandle = choice.dataset.printerHandle;
      save.dataset.printerHandle = selectedHandle;
      save.dataset.saveLabel = choice.dataset.printerName + ' opslaan als mijn printer';
      save.setAttribute('data-ucw-printer-save', '');
      window.UCWPrinterComponents?.refresh();
    }
  }
  document.addEventListener('ucw:printer-context-ready', update);
  document.addEventListener('ucw:printers-updated', update);
  store.ready.then(update);
  window.UCWPrinterContext?.ready?.then(update);
})();

